export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const GET_DATA_TRANS = 'GET_DATA_TRANS';
export const CHANGE_LOCALE_LIST = 'CHANGE_LOCALE_LIST';
export const UPDATE_JSON_LANG = 'UPDATE_JSON_LANG';
export const DEVICE_LOCALE = 'DEVICE_LOCALE';
